<template>
  <div class="event-info-box third-height"
       :style=" noBottomBorder ? 'border-bottom: none;' : ''"
  >
    <div>
      <v-icon :color="iconColor" size="22">
        {{ icon }}
      </v-icon>
      <span
        class="ml-5 font-weight-bold title"
        :style="`color: ${titleColor}`"
      >
          {{ title }}
        </span>
    </div>

    <div class="event-info-box-text d-flex align-content-start flex-wrap">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DisplayCard',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    titleColor: {
      type: String,
      required: false,
      default: '#fa9d05'
    },
    iconColor: {
      type: String,
      required: false,
      default: '#b7b7b7'
    },
    noBottomBorder: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style>
.event-info-box {
  padding: 1em;
  border: solid 1px #e5e5e5;
  width: 100%;
}

.event-info-box-text {
  padding-left: 3em;
}
</style>
